import { GiftItemForStore } from '../giftItem/giftItem.interface';
import { Image } from '../media/media.interface';

export enum GiftDeliveryShareStatus {
  NotShared = 'NotShared',
  Shared = 'Shared',
  Viewed = 'Viewed',
}

export enum GiftDeliveryStatus {
  WaitingAddress = 'WaitingAddress', // 배송지 입력 대기 (Individual)
  AddressSubmitted = 'AddressSubmitted', // 배송지 입력 완료
  Preparing = 'Preparing', // 상품 준비중
  Shipping = 'Shipping', // 배송중
  Delivered = 'Delivered', // 배송 완료
  Canceled = 'Canceled', // 취소
}

export enum GiftDeliveryType {
  Individual = 'Individual',
  Bulk = 'Bulk',
}

export interface GiftDeliveryRecipient {
  name: string;
  phoneNumber: string;
  address: string;
  addressDetail: string;
  postalCode: string;
  submittedAt: Date;
}

export interface GiftDeliveryShipping {
  trackingNumber: string;
  carrier: string;
  shippedAt: Date;
  deliveredAt: Date;
  deliveredImage?: string | { _id: string; url: string };
}

export interface GiftDeliveryPublicResponse {
  _id: string;
  code: string;
  seq: number;
  fullCode: string;
  type: GiftDeliveryType;
  quantity: number;
  shareStatus: GiftDeliveryShareStatus;
  deliveryStatus: GiftDeliveryStatus;
  sharedAt?: Date;
  viewedAt?: Date;
  purchasedAt: Date;
  expiresAt: Date;
  recipient?: GiftDeliveryRecipient;
  shipping?: GiftDeliveryShipping;
  giftItem: {
    name: string;
    image: Image;
    giftItemInfo: {
      name: string;
      image: Image;
      detailInfo?: string;
    };
  };
  giftOrder: {
    courtesyContent?: string;
    receiverName?: string;
    receiverPhoneNumber?: string;
  };
}

// Store에서 사용하는 타입 (주문 상세 페이지에서 deliveries virtual로 가져올 때)
export interface GiftDeliveryForStore {
  _id: string;
  code: string;
  seq: number;
  fullCode: string;
  type: GiftDeliveryType;
  quantity: number;
  shareStatus: GiftDeliveryShareStatus;
  deliveryStatus: GiftDeliveryStatus;
  sharedAt?: Date;
  viewedAt?: Date;
  confirmedAt?: Date;
  memo?: string;
  purchasedAt: Date;
  expiresAt: Date;
  recipient?: GiftDeliveryRecipient;
  shipping?: GiftDeliveryShipping;
  giftItem: GiftItemForStore | string;
  giftOrder: string;
}

// 배송지 입력 DTO
export interface GiftDeliveryAddressDto {
  name: string;
  phoneNumber: string;
  address: string;
  addressDetail?: string;
  postalCode: string;
}

// 주문 목록에서 사용하는 간소화 배송 타입 (virtual populate select)
export interface GiftDeliverySummary {
  _id: string;
  code: string;
  seq: number;
  type: GiftDeliveryType;
  quantity: number;
  shareStatus: GiftDeliveryShareStatus;
  deliveryStatus: GiftDeliveryStatus;
  sharedAt?: Date;
  viewedAt?: Date;
  recipient?: {
    name: string;
    phoneNumber: string;
    submittedAt: Date;
  };
}

// Admin용 배송 관리 타입 (giftOrder, giftItem populate)
export interface GiftDeliveryOrderInfo {
  _id: string;
  receiverName?: string;
  receiverPhoneNumber?: string;
  deliveryMode?: string;
  paymentDetail?: {
    purchasedAt?: Date;
  };
  bugo?: {
    _id: string;
    member?: {
      _id: string;
      fullName: string;
      phoneNumber: string;
    };
  };
}

export interface GiftDeliveryForAdmin {
  _id: string;
  code: string;
  seq: number;
  fullCode: string;
  type: GiftDeliveryType;
  quantity: number;
  shareStatus: GiftDeliveryShareStatus;
  deliveryStatus: GiftDeliveryStatus;
  sharedAt?: Date;
  viewedAt?: Date;
  purchasedAt: Date;
  expiresAt: Date;
  recipient?: GiftDeliveryRecipient;
  shipping?: GiftDeliveryShipping;
  giftItem: GiftItemForStore | string;
  giftOrder: GiftDeliveryOrderInfo | string;
  createdAt: Date;
  updatedAt: Date;
}

// Admin 배송 대시보드 응답
export interface DeliveryDashboardData {
  waitingAddress: GiftDeliveryForAdmin[];
  addressSubmitted: GiftDeliveryForAdmin[];
  preparing: GiftDeliveryForAdmin[];
  shipping: GiftDeliveryForAdmin[];
  todayDelivered: GiftDeliveryForAdmin[];
}

// Admin 배송 통계
export interface GiftDeliveryStatistics {
  waitingAddress: number;
  addressSubmitted: number;
  preparing: number;
  shipping: number;
  delivered: number;
  total: number;
}

// Admin 배송 검색 파라미터
export interface GiftDeliverySearchParams {
  deliveryStatus?: GiftDeliveryStatus;
  type?: GiftDeliveryType;
  recipientName?: string;
  recipientPhone?: string;
  ordererName?: string;
  dateFrom?: string;
  dateTo?: string;
}
